import React from 'react'
import { UnionInvestment } from './UnionInvestment'

export const CustomCode = ({ name }) => {
  if (name === 'UnionInvestment') {
    return <UnionInvestment />
  }
  return null
}
